// Google Ads / GA4 conversion tracking helper.
// Once you set up conversion tracking in Google Ads, paste the two IDs into
// /app/frontend/public/index.html (see the <!-- GTAG --> comment block).

export const trackEnrolmentConversion = (record) => {
  try {
    if (typeof window === 'undefined' || !window.gtag) return;
    const label = window.WBS_ADS_CONVERSION_LABEL; // e.g. 'AW-XXXX/abc123'
    if (label) {
      window.gtag('event', 'conversion', {
        send_to: label,
        value: 25000,
        currency: 'NGN',
        transaction_id: record?.id || '',
      });
    }
    window.gtag('event', 'generate_lead', {
      lead_source: record?.source || 'website',
      programme: record?.programme || '',
      value: 25000,
      currency: 'NGN',
    });
  } catch (e) { /* silent */ }
};

export const trackPhoneCall = (number) => {
  try {
    if (typeof window === 'undefined' || !window.gtag) return;
    const label = window.WBS_ADS_PHONE_LABEL;
    if (label) {
      window.gtag('event', 'conversion', {
        send_to: label,
        value: 25000,
        currency: 'NGN',
      });
    }
    window.gtag('event', 'phone_click', { number });
  } catch (e) { /* silent */ }
};

export const trackWhatsAppClick = () => {
  try {
    if (typeof window === 'undefined' || !window.gtag) return;
    const label = window.WBS_ADS_WHATSAPP_LABEL;
    if (label) window.gtag('event', 'conversion', { send_to: label });
    window.gtag('event', 'whatsapp_click');
  } catch (e) { /* silent */ }
};
